var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "960" } },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.$ct(_vm.add ? "sidebar.add-field" : "sidebar.edit-field"))
        ),
      ]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            { attrs: { stretch: "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-model-column-select", {
                    attrs: { model: _vm.browse.type, browse: _vm.browse },
                    on: {
                      inputLabel: function ($event) {
                        return _vm.onPropName($event)
                      },
                    },
                    model: {
                      value: _vm.selectedPropName,
                      callback: function ($$v) {
                        _vm.selectedPropName = $$v
                      },
                      expression: "selectedPropName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c(
                    "w-row",
                    { attrs: { stretch: "" } },
                    [
                      _vm.isJson
                        ? _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-browse-column-select-json-property", {
                                attrs: {
                                  browse: _vm.browse,
                                  fancy: "",
                                  column: _vm.selectedPropName,
                                },
                                model: {
                                  value: _vm.field.JsonProperty,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.field, "JsonProperty", $$v)
                                  },
                                  expression: "field.JsonProperty",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct("sidebar.field-label"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.field.Name,
                              callback: function ($$v) {
                                _vm.$set(_vm.field, "Name", $$v)
                              },
                              expression: "field.Name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.isDecimalSettingAllowed
                        ? _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  decimals: 0,
                                  disabled: _vm.decimals == null,
                                  icon: "times",
                                  fancy: "",
                                  label: _vm.$ct("decimals"),
                                  max: 20,
                                  min: 0,
                                },
                                on: {
                                  "icon-click": function ($event) {
                                    _vm.decimals = null
                                  },
                                },
                                model: {
                                  value: _vm.decimals,
                                  callback: function ($$v) {
                                    _vm.decimals = $$v
                                  },
                                  expression: "decimals",
                                },
                              }),
                              _c("w-checkbox", {
                                attrs: {
                                  value: _vm.decimals === null,
                                  label: _vm.$ct("enable-decimals"),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.toggleDecimals($event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isBoolean
                        ? _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-radio", {
                                attrs: {
                                  name: "sidebar-custom-boolean",
                                  checked: _vm.booleanMode == null,
                                  label: _vm.$ct("use-default-text"),
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.booleanMode = null
                                  },
                                },
                              }),
                              _c("w-radio", {
                                attrs: {
                                  name: "sidebar-custom-boolean",
                                  checked: _vm.booleanMode == "text",
                                  label: _vm.$ct("use-custom-text"),
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.booleanMode = "text"
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isBoolean && _vm.booleanMode == "text"
                        ? _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("text-if-true"),
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.textTrue,
                                  callback: function ($$v) {
                                    _vm.textTrue = $$v
                                  },
                                  expression: "textTrue",
                                },
                              }),
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("text-if-false"),
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.textFalse,
                                  callback: function ($$v) {
                                    _vm.textFalse = $$v
                                  },
                                  expression: "textFalse",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }